import { render, staticRenderFns } from "./SquareGrid.vue?vue&type=template&id=13a57b9c&scoped=true"
import script from "./SquareGrid.vue?vue&type=script&lang=js"
export * from "./SquareGrid.vue?vue&type=script&lang=js"
import style0 from "./SquareGrid.vue?vue&type=style&index=0&id=13a57b9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a57b9c",
  null
  
)

export default component.exports